import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

export default function NotFoundPage() {
  const { pathFor } = useLanguage();
  return (
    <section className="error-page container-wide">
      <span className="error-code">404</span>
      <h1>Page not found</h1>
      <p>The page you're looking for doesn't exist or has been moved.</p>
      <Link className="button-dark" to={pathFor("/")}>Back to home</Link>
    </section>
  );
}
